<template>
    <div class="subpage-wrapper">
        <div class="subpage-page__title">
            消息中心
        </div>
        <div class="ui-divider" />
        <div class="data-box__wrapper">
            <div class="data-box">
                <div class="table-box">
                    <el-table :data="listData">
                        <el-table-column
                            prop="title"
                            label="标题"
                            align="center"
                        />
                        <el-table-column
                            prop="status"
                            width="100px"
                            label="状态"
                            align="center"
                        />
                        <el-table-column
                            prop="time"
                            width="180px"
                            label="时间"
                            align="center"
                        />
                        <el-table-column
                            width="140px"
                            label="操作"
                            align="center"
                        >
                            <template>
                                <el-button
                                    type="text"
                                    @click="handleView"
                                >
                                    查看
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <announcement
            :visible="isAnnouncementModalVisible"
            @update:status="handleStatus"
        />
    </div>
</template>
<script>
import Announcement from '@/components/Announcement'
export default {
    name: 'AccountNotification',
    components: {
        Announcement
    },
    data () {
        return {
            isAnnouncementModalVisible: false,
            listData: [
                {
                    title: '关于《企业会员服务协议》更新通知',
                    time: '2024-06-05 15:47:23',
                    status: '已读'
                }
            ]
        }
    },
    methods: {
        handleView () {
            this.isAnnouncementModalVisible = true
        },
        handleStatus (status) {
            this.isAnnouncementModalVisible = false
        }
    }
}
</script>

<style scoped lang="scss"></style>
